import * as Yup from "yup";

import { checkArrayMaxLength } from "utils/validation";

export const validationSchema = Yup.object().shape({
  poaDocuments: checkArrayMaxLength(10).required(),
});
